import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Building, Factory, Users, Layers, CheckCircle } from 'lucide-react';
import { mockServices } from '../mock';

const Services = () => {
  const { t } = useTranslation();

  const getIcon = (iconName) => {
    const icons = {
      building: Building,
      factory: Factory,
      users: Users,
      layers: Layers
    };
    const IconComponent = icons[iconName] || Building;
    return <IconComponent className="w-8 h-8" />;
  };

  return (
    <section id="servicios" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('services.description')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {mockServices.map((service) => (
            <Card key={service.id} className="bg-gray-900 border-gray-700 hover:border-red-500 transition-all duration-300 hover:shadow-xl hover:shadow-red-500/10 group">
              <CardHeader className="pb-4">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="p-3 bg-red-600/20 rounded-lg text-red-500 group-hover:bg-red-600 group-hover:text-white transition-all duration-300">
                    {getIcon(service.icon)}
                  </div>
                  <div>
                    <CardTitle className="text-xl text-white group-hover:text-red-500 transition-colors duration-300">
                      {t(`services.services.${service.id}.title`)}
                    </CardTitle>
                  </div>
                </div>
                <CardDescription className="text-gray-400 text-base leading-relaxed">
                  {t(`services.services.${service.id}.description`)}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <h4 className="text-red-500 font-semibold mb-3">{t('services.includes')}</h4>
                  {service.features.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <CheckCircle className="w-5 h-5 text-red-500 flex-shrink-0" />
                      <span className="text-gray-300">{t(`services.services.${service.id}.features.${index}`)}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-red-600/20 to-red-600/10 border border-red-600/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              {t('services.quote.title')}
            </h3>
            <p className="text-gray-300 mb-6 text-lg">
              {t('services.quote.description')}
            </p>
            <button
              onClick={() => {
                const element = document.querySelector('#contacto');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 hover:shadow-xl hover:scale-105"
            >
              {t('services.quote.button')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;